import ExportedImage from '@/components/shared/ExportedImage';

import { motion } from 'framer-motion';

import cryptoCoinsBg from '@/public/images/lp/komodo-wallet/500-cryptos-bg.png';
import cryptoCoins from '@/public/images/lp/komodo-wallet/500-cryptos-coins.png';

export const ListedCryptos500 = () => {
  return (
    <>
      <section className='mx-auto flex pt-24 md:pb-20 md:pt-12 3xl:pb-24'>
        <div className='mx-auto text-center'>
          <h2 className='listed-crypto text-3xl font-bold leading-[35.69px] md:text-4xl md:leading-[48px]'>
            500+ Listed Cryptocurrencies
          </h2>
          <p className='pt-4 text-center text-sm font-medium xl:text-lg 2xl:pt-8'>
            With more being added in each new release
          </p>

          <div className='cryptos-500-img-div relative mt-10'>
            <ExportedImage
              placeholder='empty'
              src={cryptoCoins}
              alt='group coins'
              id='cryptos-500-plus-coins'
              className='relative z-[11] mx-auto h-auto scale-[70%] lg:w-[700px] 2xl:w-[900px]'
            />
            <motion.div
              initial={{ opacity: 0 }}
              //animate={{ rotate: 260, opacity: 1 }}
              transition={{ duration: 3 }}
              viewport={{ once: true, amount: 0.3 }}
              whileInView={{ rotate: 260, opacity: 1 }}
              className='z-[-10]'
            >
              <ExportedImage
                placeholder='empty'
                src={cryptoCoinsBg}
                alt='group coins bg'
                id='cryptos-500-plus-bg'
                className='relative z-[10] mx-auto h-auto rotate-90 lg:w-[700px] 2xl:w-[900px]'
              />
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};
